/**
 * uxGtmEventSend
 * @param {string} eventName
 * @param {object} params
 */
export const uxGtmEventSend = (eventName, params) => {
  gtag('event', eventName, {
    ...params,
    send_to: process.env.VUE_APP_UX_GA4_CODE,
  });
};

/**
 * sendUxGTMCartNumChange
 * @param {string} eventName
 * @param {object} item
 */
export const sendUxGTMCartNumChange = (eventName, item) => {
  const allowEventName = ['cart_change_num', 'cart_move_to_collection', 'cart_delete_item'];
  if (!allowEventName.includes(eventName)) return;
  try {
    const finalPrice = parseInt(item?.finalPrice || item?.productPrice, 10) || 0;
    uxGtmEventSend(eventName, {
      item_id: item?.martCode || '',
      item_name: item?.productName || '',
      item_variant: item?.productNo || '',
      item_brand: item?.productBrand || '',
      item_category: Object.keys(item?.categories || []).join('/'),
      price: finalPrice,
      quantity: parseInt(item.productQty, 10) || 0,
    });
  } catch (err) {
    console.log(`sent GA4 event error:${err}`);
  }
};
